import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: 'lg',
    fontFamily: 'Staatliches',
    letterSpacing: '1px',
    fontWeight: 'normal',
    color: 'white',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    mb: '2',
    textTransform: 'uppercase',
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: '0',
  },
  hStackWrapper: {
    justifyContent: 'flex-end',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'white',
  },
  scrollButtonGroup: {
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    variant: 'filter',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'lg',
    gap: '1',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontFamily: 'Staatliches',
    letterSpacing: '1px',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    color: 'white',
  },
  headingIcon: {
    color: 'alpha.400',
  },
  propositionButton: {
    variant: 'odds',
    flex: '1',
    height: '38px',
    bgGradient: 'linear(to-b, gamma.300, gamma.500)',
    display: 'initial',
  },
  boxSportWrapper: {
    display: 'none',
  },
  buttonSport: {
    pr: '30px',
    bg: 'transparent',
    borderColor: 'gamma.400',
    _hover: {
      color: 'alpha.700',
      bgGradient: 'linear(to-b, gamma.300, gamma.400)',
      '&:after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        border: '1px',
        borderColor: 'alpha.700',
        boxSize: '2.5',
        top: '7px',
        right: '2.5',
        borderRadius: 'full',
        pr: '2',
      },
    },
    sx: {
      '&:after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        border: '1px',
        borderColor: 'gamma.200',
        boxSize: '2.5',
        top: '7px',
        right: '2.5',
        borderRadius: 'full',
        pr: '2',
      },
    },
  },
  buttonAllSports: {
    bg: 'transparent',
    _active: {
      bgGradient: 'linear(to-b, gamma.300, gamma.400)',
      color: 'alpha.700',
      border: 'none',
      '&:after': {
        display: 'none',
      },
    },
  },
  segmentedButtonSortByTime: {
    h: '21px',
    color: 'white',
    fontSize: '2xs',
    textTransform: 'uppercase',
    fontWeight: 'extrabold',
    _hover: {
      color: 'white',
    },
    _active: {
      bgGradient: 'linear(to-b, gamma.300, gamma.400)',
      color: 'alpha.700',
    },
  },
  segmentedButtonSortBySport: {
    h: '21px',
    color: 'white',
    fontSize: '2xs',
    textTransform: 'uppercase',
    fontWeight: 'extrabold',
    _hover: {
      color: 'gamma.200',
    },
    _active: {
      bgGradient: 'linear(to-b, gamma.300, gamma.400)',
      color: 'alpha.700',
    },
  },
};
